module.exports = __webpack_public_path__ + "img/champion-floating-vn.784f28f3.gif";